import { Box, Typography, useTheme, Stack, Chip } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export default function HeroLanding() {
  const theme = useTheme();
      const [typedText, setTypedText] = useState("");
  const indexRef = useRef(0);
  const fullTextRef = useRef(" 🧬 4 models trained | ⚕️ ISO-pending");
// 📈 5,312 cases |
    useEffect(() => {
    const interval = setInterval(() => {
      setTypedText((prev) => {
        const nextChar = fullTextRef.current[indexRef.current];
        indexRef.current += 1;
        if (indexRef.current > fullTextRef.current.length) {
          clearInterval(interval);
          return prev;
        }
        return prev + nextChar;
      });
    }, 40); // speed in ms

    return () => clearInterval(interval);
  }, []);

  return (  
  <>
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      sx={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 2
      }}
    >
      <Stack spacing={0.5} alignItems="center">
        <motion.img
          src="/assets/brain.png"
          alt="Chat Noetiv"
          initial={{ scale: 0.4, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 2 }}
          style={{ width: 229, height: 196 }}
        />

        <Box>
          <Typography
            variant="h3"
            component="h1"
            fontWeight="bold"
            sx={{
            //   display: 'inline-flex',
              alignItems: 'baseline',
              gap: 0
            }}
          >
            Noetiv-Skin
            <Typography
              component="sup"
              variant="caption"
              sx={{
                background: theme.palette.primary.main,
                color: 'white',
                px: 1,
                borderRadius: '12px',
                fontSize: '0.5em',
                ml: 0.7,
                mt: 0
              }}
            >
              AI
            </Typography>
          </Typography>
        </Box>

        <Typography variant="h6" color="text.secondary">
          Empowering dermatology with precision AI.
        </Typography>

        <Chip
          label="Pilot"
          color="secondary"
          size="medium"
          sx={{ mt: 0.5, fontWeight: 'bold' }}
        />
      </Stack>
      
    </Box>
        {/* ✅ Typing effect */}
      <Box sx={{ textAlign: 'center', mt: 0, zIndex: 0, position: 'relative', minHeight: '1.5em' }}>
        <Typography variant="subtitle1" color="text.secondary">
          {typedText}
        </Typography>
      </Box>
</>
  );
}